import { Reveal, Overline } from "./Reveal";
import { Check } from "lucide-react";
import { SITE } from "@/config/site";

const GROUP = [
  "20 live group sessions (10 learning + 10 trading)",
  "Sessions 1–10: USD 2,000 (weekly)",
  "Sessions 11–20: USD 2,000 (bi-weekly)",
  "Full session recordings on Zoom",
  "Dedicated WhatsApp group for Q&A",
  "Homework & accountability after each session",
];

const ONE = [
  "Everything in the group program",
  "Private, personalised coaching",
  "Flexible scheduling around you",
  "Upgrade available before session 10",
  "Direct 1:1 access to Diego",
  "Bespoke strategy tailored to your capital",
];

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="relative py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="max-w-2xl mb-16">
          <Overline>Investment</Overline>
          <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-tight text-white mt-5">
            Choose how you want to learn.
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-6">
          {/* Group */}
          <Reveal>
            <div className="relative h-full rounded-3xl border border-burgundy/60 bg-surface/50 p-10 overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-1 bg-burgundy" />
              <div className="absolute -top-24 -right-24 h-64 w-64 bg-burgundy/20 blur-3xl rounded-full" />
              <span className="font-mono text-xs uppercase tracking-[0.25em] text-burgundy">Group Program</span>
              <div className="mt-6 flex items-end gap-2">
                <span className="font-display text-6xl text-white">USD 2,000</span>
                <span className="text-slate-400 mb-2 text-sm">/ per phase</span>
              </div>
              <p className="text-slate-400 text-sm mt-3">Per participant · two phases across the full cohort.</p>
              <ul className="mt-8 space-y-4">
                {GROUP.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-slate-200 text-sm">
                    <Check size={16} className="text-burgundy mt-0.5 shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>
              <a
                href={SITE.stripeLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="pay-group-btn"
                className="mt-10 block text-center bg-burgundy hover:bg-burgundy-hover text-ink font-semibold font-mono text-xs uppercase tracking-[0.2em] py-4 rounded-full transition-colors duration-300"
              >
                Secure your seat
              </a>
            </div>
          </Reveal>

          {/* 1:1 */}
          <Reveal delay={0.1}>
            <div className="h-full rounded-3xl border border-white/10 bg-ink p-10">
              <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">1:1 Private Coaching</span>
              <div className="mt-6 flex items-end gap-2">
                <span className="font-display text-6xl text-white">Bespoke</span>
              </div>
              <p className="text-slate-400 text-sm mt-3">Consult with Diego to tailor a personalised journey and schedule.</p>
              <ul className="mt-8 space-y-4">
                {ONE.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-slate-200 text-sm">
                    <Check size={16} className="text-slate-400 mt-0.5 shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>
              <a
                href="#enquire"
                data-testid="enquire-1on1-btn"
                className="mt-10 block text-center border border-white/20 hover:border-burgundy text-white font-mono text-xs uppercase tracking-[0.2em] py-4 rounded-full transition-colors duration-300"
              >
                Consult with Diego
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
